export default "__VITE_ASSET__6QvcvKYw__"